export enum Gender {
  MALE = 'M',
  FEMALE = 'F',
  NON_BINARY = 'N',
}
